export default __webpack_public_path__ + "static/media/vscode.942ebbc7.png";